export default __webpack_public_path__ + "static/ar-EG-884a7d77676dcf88cac12442fc2d4f52.svg";